import React, {Suspense} from 'react';
import {Preloader} from '@ab/components';

const Main = React.lazy(() => import(/* webpackChunkName: "Deposit" */ './views/main.c'));

const Deposit = props => {
    let {match = {}} = props;

    return (
        <Suspense fallback={<Preloader className="center" />}>
            <Main {...props} action={match.params && match.params.action} />
        </Suspense>
    );
};

export default Deposit;
